<template>
    <div class="list-group" @click="$emit('click')">
        <div>
            <div class="bg"></div>
            <div class="banner">
                <div class="empty-box">
                    <img class="shan" src="@/assets/img/img-icon.png" alt="" />
                </div>
            </div>
        </div>

        <div>
            <div class="dot">
                <div v-for="i in 3" :key="i" class="dot-item"></div>
            </div>
        </div>

        <div class="delete-box">
            <div class="handleType">
                <div class="iconfont" @click="remove()">
                    <i class="el-icon-delete"></i>
                </div>
                <div class="iconfont">
                    <i class="el-icon-copy-document" @click="copy()"></i>
                </div>
                <div class="iconfont" :class="{ disabled: index === 0 }" @click="downward()">
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div class="iconfont" @click="upward()" :class="{ disabled: index >= finallyIndex }">
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
        </div>

        <div class="delete-name">轮播图</div>
    </div>
</template>

<script>
export default {
    props: {
        index: {
            type: Number,
            default: null
        },
        finallyIndex: {
            type: Number,
            default: null
        }
    },
    methods: {
        remove() {
            this.$emit('remove', '');
        },
        copy() {
            this.$emit('copy', '');
        },
        downward() {
            this.$emit('downward', '');
        },
        upward() {
            this.$emit('upward', '');
        }
    }
};
</script>

<style lang="scss" scoped>
.on {
    scale: 1.01;
    .delete-box {
        display: block !important;
        border: 2px solid #0256ff !important;
        box-shadow: 0 0 10px 0 rgba(24, 144, 255, 0.3) !important;
    }

    .delete-name {
        display: block !important;
        background: #4d88ff !important;
        color: #fff !important;
        &::before {
            background: #4d88ff !important;
        }
    }
}

.disabled {
    opacity: 0.4 !important;
}

.list-group:hover {
    scale: 1.01;
    box-shadow: 0 0 10px 0 rgba(24, 144, 255, 0.3);
    transition: all 0.2s;
}

.list-group {
    width: 100%;
    position: relative;
    transition: all 0.2s;
    background-color: #fff;

    .bg {
        width: 100%;
        height: 96px;
        background: rgb(246, 44, 44);
    }

    .banner {
        // width: 100%;
        margin-top: -96px;
        padding: 10px;

        .empty-box {
            width: 100%;
            height: 100%;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            background: #f3f5f7;
            border-radius: 6px;
            height: 170px;
            background-color: #f3f9ff;
            border-radius: 10px;
            .shan {
                width: 65px !important;
                height: 50px !important;
            }
        }
    }

    .dot {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        // width: 100%;
        display: flex;
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 20px;
        justify-content: center;

        .dot-item {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin: 0 3px;
            background: #ddd;
        }

        .dot-item:first-child {
            background: rgb(233, 51, 35);
        }
    }

    .delete-name {
        position: absolute;
        top: 0;
        background: #fff;
        left: -100px;
        width: 86px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        color: #666;
        border-radius: 3px;
        // display: none;

        &::before {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
            background: #fff;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            top: 50%;
            right: -5px;
            margin-top: -5px;
        }
    }

    .delete-box {
        display: none;
        position: absolute;
        left: -2px;
        top: 0;
        width: 375px;
        height: 100%;
        border: 2px dashed #0256ff;
        .handleType {
            position: absolute;
            right: -43px;
            top: 0;
            width: 36px;
            border-radius: 4px;
            background-color: #0256ff;
            cursor: pointer;
            color: #fff;
            font-weight: 700;
            text-align: center;
            padding: 4px 0;

            .iconfont {
                padding: 5px 0;
            }
        }
    }
}
</style>